export const RESOURCE_BUILDING_BLOCK_DEBUG_METADATA_KEY = "buildingBlocks";

export interface BuildingBlockDebugState {
  enabled: boolean;
  source: "block" | "resource" | null;
}

export function isResourceBuildingBlockDebugEnabled(
  metadata: Record<string, unknown> | null | undefined,
): boolean {
  const settings = metadata?.[
    RESOURCE_BUILDING_BLOCK_DEBUG_METADATA_KEY
  ];
  return Boolean(
    settings
    && typeof settings === "object"
    && !Array.isArray(settings)
    && (settings as { debug?: unknown }).debug === true,
  );
}

export function setResourceBuildingBlockDebug(
  metadata: Record<string, unknown> | null | undefined,
  enabled: boolean,
): Record<string, unknown> {
  const current = metadata?.[
    RESOURCE_BUILDING_BLOCK_DEBUG_METADATA_KEY
  ];
  const settings =
    current && typeof current === "object" && !Array.isArray(current)
      ? current as Record<string, unknown>
      : {};

  return {
    ...(metadata ?? {}),
    [RESOURCE_BUILDING_BLOCK_DEBUG_METADATA_KEY]: {
      ...settings,
      debug: enabled,
    },
  };
}

export function resolveBuildingBlockDebug(input: {
  blockDebug?: unknown;
  resourceDebug?: unknown;
}): BuildingBlockDebugState {
  if (input.resourceDebug === true) {
    return { enabled: true, source: "resource" };
  }
  if (input.blockDebug === true) {
    return { enabled: true, source: "block" };
  }
  return { enabled: false, source: null };
}
